import { useEffect, useState } from 'react';
import { collection, getDocs, onSnapshot } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { Event } from '@/components/flood-events/types';

export function useEvents() {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    async function loadEvents() {
      try {
        const eventsSnap = await getDocs(collection(db, 'events'));
        if (!mounted) return;
        
        const eventsData = eventsSnap.docs.map(d => ({ 
          id: d.id, 
          ...d.data() 
        })) as Event[];

        setEvents(eventsData);
        setError(null);
      } catch (err) {
        console.error('Failed to load events', err);
        if (mounted) setError(err instanceof Error ? err.message : String(err));
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadEvents();

    // Set up real-time listener for updates
    const unsubscribe = onSnapshot(
      collection(db, 'events'),
      (snapshot) => {
        if (mounted) {
          const eventsData = snapshot.docs.map(d => ({ 
            id: d.id, 
            ...d.data() 
          })) as Event[];
          setEvents(eventsData);
        }
      },
      (err) => {
        console.error('Events subscription error:', err);
        if (mounted) setError(err.message);
      }
    );

    return () => { 
      mounted = false;
      unsubscribe();
    };
  }, []);

  return { events, loading, error };
}
